import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import noop from 'lodash/noop';
import cn from 'classname';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	toggleDetails: PropTypes.func,
	listOfRefererTypes: PropTypes.array,
	currentCurrency: PropTypes.string,
	isIndexing: PropTypes.bool
};

const Table = ({
	table,
	intl,
	can,
	sortByColumn,
	showMoreRows,
	toggleCheckedItems,
	toggleResendPopup,
	checkedBan,
	isIndexing
}) => (
	<div className="table-container">
		<table className="simple-table conversions-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								'active': table.sortedColumn.index === header.index,
								[table.sortedColumn.direction]: (
									table.sortedColumn.index === header.index && table.sortedColumn.direction
								),
								[header.className]: header.className
							})}
							onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
					))}
				</tr>
			</thead>

			<tbody
				className={cn({
					'simple-table__body': true,
					'table-indexing': isIndexing,
					'default-table-indexing': isIndexing
				})}
			>
				{ renderRows( table, toggleResendPopup, can, toggleCheckedItems, checkedBan ) }
			</tbody>
		</table>
		<div className="table-container__navigation">
			{ table.shouldShowPaginationControl && (
				<button className="ui-btn ui-btn-secondary" onClick={() => showMoreRows()}>{intl('Show more')}</button>
			)}
		</div>
	</div>
);

const renderRows = (
	table, toggleResendPopup, can, toggleCheckedItems, checkedBan
) => {
	const elements = [];
	const { rows } = table;

	rows.forEach(row => {
		elements.push(
			<Row
				key={row.id} row={row} toggleResendPopup={toggleResendPopup} can={can} toggleCheckedItems={toggleCheckedItems}
				checkedBan={checkedBan}
			/>
		);
	});

	return elements;
};

class Row extends React.Component  {
	constructor(props) {
		super(props);
		this.state = { isChecked: false };
		this.toggleCheck = this.toggleCheck.bind(this);
	}

	toggleCheck(type) {
		if (type !== 'spam_by_ip') {
			return alert(`Can check only spam_by_ip. Other leads need to be resended one by one.`);
		}
		this.setState(state => ({ isChecked: !this.state.isChecked }));
		this.props.toggleCheckedItems(this.props.row.id);
	}

	render() {
		const { row, toggleResendPopup, can } = this.props;
		const { isChecked } = this.state;
		return (
			<tr key={row.id} className={cn({'checked-ban': isChecked})}>
				<td className="date"><span>{moment(row.date).format('DD.MM.YYYY HH:mm')}</span></td>
				<td><span>{ row.id }</span></td>
				<td><span>{ row.campaign_id } <p>({ row.is_archived_campaign ? 'Archived' : 'Active' })</p></span></td>
				<td><span>{ row.affiliate }</span><p>({row.affiliate_id});</p><p>Manager: {row.manager}</p></td>
				<td><span>{ row.offer }</span><p className="margin-10-0-0-0">Status: {row.offer_status}</p></td>
				<td><div className="payload-content">
					<span>{ JSON.stringify(row.payload) }</span>
					{row.validation_message && <p className="margin-10-0-0-0"> Message: {row.validation_message} </p>}
				</div></td>
				<td><span>{ row.type }</span></td>
				<td className="actions">
					<input
						type="checkbox"
						className="margin-0-10"
						checked={this.props.checkedBan.includes(row.id)}
						onClick={this.toggleCheck.bind(null, row.type)}
					/>
					{
						can('resend') &&
						<span className="resend_conversions-hint">
							<a className='action_resend' onClick={toggleResendPopup.bind(null, row.id)} />
						</span>
					}
				</td>
			</tr>
		);
	}
}

Table.propTypes = propTypes;

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/unacceptable-conversions/main.js